import React from 'react';
import Ggaek from '../assets/ggaek.png';

const Analytics = () => {
  return (
    <div className="w-full bg-white py-16 px-4">
      <div className="max-w-[1240px] mx-auto grid md:grid-cols-2">
        <img className="w-[350px] mx-auto my-4" src={Ggaek} alt="/" />
        <div className="flex flex-col justify-center">
          <p className="text-[#00df9a] font-bold ">Сокровища Беларуси</p>
          <h1 className="md:text-4xl sm:text-3xl text-2xl font-bold py-2">
            Игровой обучающий контент
          </h1>
          <p>Пройди квест и получи сокровища</p>
          <a href='https://disk.yandex.ru/d/6Xvpt5uaDgT5kA'> <button className="bg-black text-[#00df9a] w-[200px] rounded-md font-medium my-6 mx-auto md:mx-0 py-3">
            Скачать
          </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
